import { CellInput } from 'jspdf-autotable';
import { Filter } from '../../../Enum/Filters';
import { ServiceContainer } from '../../ServiceContainer/ServiceContainer';
import { constructionTypeReadable } from '../../../Enum/Filters/ConstructionType';
import { capitalizeFirstLetter } from '../../../Helpers/String';
import { loanFormReadable } from '../../../Enum/Filters/LoanForm';
import { decorateLegendaCell } from './Styles';
import { getLabelByIdentifier } from '../../../Helpers/Interest/PeriodHelper';

export const filterToPdfTableCell = (filterProperty: Filter): CellInput[] | undefined => {
    const filteredValues = ServiceContainer.storeGateway.getState().filter.filteredValues;
    switch (filterProperty) {
        case Filter.ConstructionType:
            return [
                decorateLegendaCell('Soort woning'),
                decorateLegendaCell(constructionTypeReadable(filteredValues[filterProperty])),
            ];
        case Filter.EnergyLabel:
            return [decorateLegendaCell('Energielabel'), decorateLegendaCell(filteredValues[filterProperty])];
        case Filter.FixedPeriod:
            return [
                decorateLegendaCell('Rentevastperiode'),
                decorateLegendaCell(getLabelByIdentifier(filteredValues[filterProperty])),
            ];
        case Filter.Label:
            return [decorateLegendaCell('Product'), decorateLegendaCell(filteredValues[filterProperty])];
        case Filter.LoanForm:
            return [
                decorateLegendaCell('Aflossingsvorm'),
                decorateLegendaCell(loanFormReadable(filteredValues[filterProperty])),
            ];
        case Filter.NHG:
            return [
                decorateLegendaCell('NHG'),
                decorateLegendaCell(capitalizeFirstLetter(filteredValues[filterProperty])),
            ];
        case Filter.RiskCategory:
            return [
                decorateLegendaCell('Marktwaardepercentage'),
                decorateLegendaCell(`${filteredValues[filterProperty]}%`),
            ];
        case Filter.Account:
            return [
                decorateLegendaCell('Betaalrekening'),
                decorateLegendaCell(capitalizeFirstLetter(filteredValues[filterProperty])),
            ];
    }
};
